module.exports = __webpack_public_path__ + "static/media/xebia.a4e08643.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/xebia.webp
// module id = 831
// module chunks = 0